import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { MARKETING_PAGE_HOW_TO_USE_INSIDER_CAROUSEL_IMAGE_URLS } from "@faire/web-api--source/indigofair/settings/MARKETING_PAGE_HOW_TO_USE_INSIDER_CAROUSEL_IMAGE_URLS";
export var getSettingInsiderMarketingPageImageUrls = function() {
    return getSettingValueWithoutAssignment(MARKETING_PAGE_HOW_TO_USE_INSIDER_CAROUSEL_IMAGE_URLS, []);
};
